import app from 'lib/init'
import 'lib/accessibility'
import 'lib/product-card'
import 'lib/featured-products-slider'
import store from 'store'

document.addEventListener('DOMContentLoaded', () => {
  // This call looks in the DOM for all "data-module"
  // attributes and instantiates relevant modules
  // based on the attributes found.
  app.init()
  store.dispatch('cart/hydrateProductsOnCart')
})
